/* eslint-ignore */
// @ts-nocheck
import { Field as FormikField, Form, Formik } from 'formik';
import React, { Component } from 'react';
import { Form as BootstrapForm, Modal } from 'react-bootstrap';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { ReactComponent as VpnKey } from '~/assets/icons/key.svg';
import { ReactComponent as PermContactCalendar } from '~/assets/icons/perm_contact_calendar.svg';
import ContainedButton from '~/components/layout/form/containedButton';
import OutlinedButton from '~/components/layout/form/outlinedButton';
import TextField from '~/components/layout/form/textField';
import api from '~/services/api';
import theme from '~/styles/theme';
import ModalFindYourCode from '../Modal/findYourCode';
import StyledButton from '../../../../layout/button';
import axios from 'axios';
import {
  FormBox,
  FormHeader,
  AdressLineContainer,
  AdressLine,
  AdressItem,
  AdressName,
  AdressIcon,
  AdressNameContainer,
  AdressInfoContainer,
  Select,
  AddressWrapper,
  Hr,
  AddressContainer,
  AddressButtonContainer,
  AddressItemContainer,
} from './styles';
import {
  apiHateoas,
  registerDocument,
  toggleStep,
} from '~/store/actions/singup-actions';
import {
  formatDocumentForDisplay,
  normalizeDocumentForPayload,
  sanitizeDocument,
  validateDocument,
} from '~/utils/document';

class SignupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showModal: false,
      nfe: false,
      ndd: false,
      coletor2: false,
      addressSection: false,
      adresses: [],
      hateoas: '',
      user: '',
      document: '',
      selectedAdress: {},
    };
  }

  SignUpSchema = () =>
    Yup.object().shape({
      user: Yup.number().required('Insira um código'),
    });

  validateUser = (value) => {
    let error;
    if (!value) {
      error = 'É obrigatório preencher seus dados!';
    }
    if (!/[^\d-.\/]/.test(value)) {
      const numbers = value.replace(/[^\d]/g, '');
    }
    return error;
  };

  handleDocument = (e, handleChange) => {
    const event = e;
    const sanitized = sanitizeDocument(event.target.value);
    event.target.value = formatDocumentForDisplay(sanitized);
    handleChange(event);
  };

  handleUser = (e, handleChange) => {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, '');
    event.target.value = event.target.value.replace(/[^\d]/g, '');
    if (numbers.length === 30) {
      event.target.value = numbers;
    }
    handleChange(event);
  };

  requestGetAccessToken = async () => {
    const req = axios.create({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": "pt-BR",
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
      baseURL: process.env.REACT_APP_API_URL_OAUTH,
    });

    const header = {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      grant_type: 'client_credentials',
    };

    let access_token = '';

    try {
      const response = await req.post('oauth/access-token', body, parameters);
      access_token = response.data.access_token;
    } catch (error) {
      const erro = error.response;
      if (erro) {
        const { message } = error.response.data;
        if (error.response.status !== 401) {
          toast.error(message);
        }
      } else if (error.response.status !== 401) {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }

    return access_token;
  };

  addressContinue = (siteId, userId) => {
    this.props.dispatch(apiHateoas(this.state.hateoas));
    this.props.dispatch(
      registerDocument(this.state.document, this.state.user, siteId, userId)
    );
    this.props.dispatch(toggleStep(2));
    this.setState({ loading: false });
  };

  getUserId = async (siteId) => {
    const { document, user } = this.state;

    const header = {
      'Content-Type': 'application/json',
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    const body = {
      customerCode: user,
      document,
      siteId,
    };

    const responseUsers = await api.post(
      'industrial/customer/v1/users',
      body,
      parameters
    );

    let userId = null;

    if (responseUsers.status === 201) {
      const hateoas = responseUsers.headers.location;
      userId = hateoas.split('/').pop();
    }

    return userId;
  };

  requestRegister = async (values) => {
    this.setState({ loading: true });
    values.document = normalizeDocumentForPayload(values.document);

    const { user: customerCode, document } = values;

    this.setState({
      document,
      user: customerCode,
    });

    try {
      const access_token = await this.requestGetAccessToken();
      const documentParam = encodeURIComponent(
        normalizeDocumentForPayload(document)
      );
      const customerCodeParam = encodeURIComponent(customerCode);

      const responseAddress = await api.get(
        `industrial/customer/v1/customers?document=${documentParam}&code=${customerCodeParam}&type=EMP&_expand=CONTACT`,
        {
          headers: {
            access_token,
            client_id: process.env.REACT_APP_CLIENT_ID,
          },
        }
      );

      if (responseAddress.status === 200) {
        const [costumerData] = responseAddress.data;

        if (!costumerData)
          throw new Error(
            'Nenhum cliente encontrado. Verifique os dados digitados e tente novamente.'
          );
        const customerAddresses = costumerData.customerAddresses.filter(
          (address) => address.addressType === 'SHIP_TO'
        );

        if (customerAddresses.length >= 2) {
          this.setState({
            addressSection: true,
            adresses: customerAddresses,
            loading: false,
          });
          return;
        }
        const [costumerFirstAddress] = customerAddresses;
        const { siteId } = costumerFirstAddress;

        const userId = await this.getUserId(siteId);

        if (siteId) {
          this.addressContinue(siteId, userId);
        } else {
          toast.error('Não conseguimos identificar seu endereço!');
        }
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    } catch (err) {
      const erro = err.response;
      this.setState({ loading: false });

      if (erro) {
        const message = err.response.data[0]
          ? err.response.data[0].message
          : err.response.data.message;

        const status = err.response.data[0]
          ? err.response.data[0].status
          : err.response.data.status;

        if (status !== 401) {
          toast.error(message);
        }
      } else {
        const status = err.response?.status || false;
        if (status !== 401) {
          if (err.message) {
            toast.error(err.message);
          } else {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        }
      }
    }
  };

  handleShow = () => {
    this.setState({ showModal: true });
  };

  render() {
    const { props } = this;
    return (
      <FormBox>
        {this.state.addressSection ? (
          <>
            <FormHeader>
              <h2>
                Encontramos os seguintes endereços vinculados a sua conta:
              </h2>
              <h3>Selecione endereço desejado para seguir com o cadastro.</h3>
            </FormHeader>

            <AddressWrapper>
              <AddressContainer>
                <AddressItemContainer>
                  {this.state.adresses.map((item) => {
                    const base = item;

                    return (
                      <div key={base.siteId}>
                        <AdressItem
                          key={base.siteId}
                          htmlFor={base.siteId}
                          name={base.siteId}
                          border={
                            this.state.selectedAdress.siteId === base.siteId
                          }
                        >
                          <Select
                            type="radio"
                            id={base.siteId}
                            name={base.siteId}
                            checked={
                              this.state.selectedAdress.siteId === base.siteId
                            }
                            onChange={() => {
                              this.setState({ selectedAdress: item });
                            }}
                          />
                          <AdressInfoContainer>
                            <AdressNameContainer>
                              <AdressLine>
                                {(this.state.adresses.name || '')
                                  .toLowerCase()
                                  .replace(/(?:^|\s)\S/g, function (a) {
                                    return a.toUpperCase();
                                  })}
                              </AdressLine>
                            </AdressNameContainer>
                            <AdressLineContainer>
                              <AdressLine>
                                {(base.addressLine || '')
                                  .toLowerCase()
                                  .replace(/(?:^|\s)\S/g, function (a) {
                                    return a.toUpperCase();
                                  })}
                                ,
{' '}
                                {(base.addressNumber || '')
                                  .toLowerCase()
                                  .replace(/(?:^|\s)\S/g, function (a) {
                                    return a.toUpperCase();
                                  })}
                                {base.complement ? ' - ' : ''}
                                {(base.complement || '')
                                  .toLowerCase()
                                  .replace(/(?:^|\s)\S/g, function (a) {
                                    return a.toUpperCase();
                                  })}
                                {' - '}
                                {(base.city || '')
                                  .toLowerCase()
                                  .replace(/(?:^|\s)\S/g, function (a) {
                                    return a.toUpperCase();
                                  })}
                                {' - '}
                                {(base.stateCode || '')
                                  .toLowerCase()
                                  .replace(/(?:^|\s)\S/g, function (a) {
                                    return a.toUpperCase();
                                  })}
                              </AdressLine>
                            </AdressLineContainer>
                            {base.code && (
                              <AdressNameContainer>
                                <AdressLine>
                                  Código de endereço: {base.code}
                                </AdressLine>
                              </AdressNameContainer>
                            )}
                          </AdressInfoContainer>
                        </AdressItem>
                      </div>
                    );
                  })}
                </AddressItemContainer>
              </AddressContainer>

              {this.state.loading ? null : (
                <AddressButtonContainer>
                  <ContainedButton
                    className="mb-2"
                    block
                    continue
                    icon="arrow-right"
                    text="Continuar"
                    loading={this.state.loading}
                    color={theme.colors.purple}
                    name="Continuar"
                    width="100%"
                    id="Continuar"
                    onClick={async () => {
                      if (this.state.selectedAdress.siteId) {
                        const userId = await this.getUserId(
                          this.state.selectedAdress.siteId
                        );
                        this.addressContinue(
                          this.state.selectedAdress.siteId,
                          userId
                        );
                      } else {
                        toast.error('Selecione um endereço para continuar!');
                      }
                    }}
                    TrailingIcon={() => <IoMdArrowForward size={20} />}
                  >
                    Continuar
                  </ContainedButton>
                  <OutlinedButton
                    onClick={() => {
                      this.setState({
                        addressSection: false,
                        selectedAdress: {},
                        adresses: [],
                      });
                    }}
                    className="mb-2"
                    block
                    outline
                    icon="arrow-left"
                    text="Voltar"
                    color={theme.colors.purple}
                    name="Voltar"
                    width="100%"
                    id="Voltar"
                    LeadingIcon={() => <IoMdArrowBack size={20} />}
                  >
                    Voltar
                  </OutlinedButton>
                </AddressButtonContainer>
              )}
            </AddressWrapper>
          </>
        ) : (
          <Formik
            initialValues={{
              user: '',
              document: '',
            }}
            onSubmit={(values) => {
              this.requestRegister(values);
            }}
            validationSchema={this.SignUpSchema}
            render={({ handleChange, handleBlur, values, errors, touched }) => (
              <>
                <FormHeader>
                  <h2>Vamos começar</h2>
                  <h3>Insira seus dados de cadastro para continuar</h3>
                </FormHeader>
                <Form>
                  <BootstrapForm.Group controlId="user">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <TextField
                            {...field}
                            type="text"
                            title="Código do Cliente"
                            placeholder="Código do Cliente *"
                            label="Código do Cliente *"
                            ariaLabel="Código do Cliente"
                            ariaRequired
                            errorCondition={errors.user && touched.user}
                            errorMessage={errors.user}
                            onBlur={handleBlur}
                            maxLength={30}
                            value={values.user}
                            LeadingIcon={() => <VpnKey />}
                            onChange={(e) => {
                              this.handleUser(e, handleChange);
                            }}
                          />
                        );
                      }}
                      validate={this.validateUser}
                      name="user"
                    />
                  </BootstrapForm.Group>
                  <div
                    className="d-flex w-100 justify-content-end align-items-center mt-1 mb-1"
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.handleShow()}
                    name="modal"
                    id="modal"
                  >
                    <span
                      style={{
                        fontSize: 14,
                        color: theme.colors.purple,
                        fontWeight: 100,
                      }}
                    >
                      Encontre seu Código
                    </span>
                    <span
                      className="mdi mdi-help-circle"
                      style={{ fontSize: 20, color: '#F0B01B', marginLeft: 5 }}
                    />
                  </div>
                  <BootstrapForm.Group controlId="document">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <TextField
                            {...field}
                            type="text"
                            title="CPF/CNPJ"
                            placeholder="CPF ou CNPJ *"
                            label="CPF ou CNPJ *"
                            ariaLabel="CPF ou CNPJ *"
                            ariaRequired
                            errorCondition={errors.document && touched.document}
                            errorMessage={errors.document}
                            onBlur={handleBlur}
                            value={values.document}
                            LeadingIcon={() => <PermContactCalendar />}
                            onChange={(e) => {
                              this.handleDocument(e, handleChange);
                            }}
                          />
                        );
                      }}
                      validate={validateDocument}
                      name="document"
                    />
                  </BootstrapForm.Group>
                  <div style={{ marginTop: 50 }}>
                    <ContainedButton
                      onPress={props.onPress}
                      className="mb-2"
                      block
                      type="submit"
                      continue
                      icon="arrow-right"
                      text="Continuar"
                      loading={this.state.loading}
                      color={theme.colors.purple}
                      name="Continuar"
                      width="100%"
                      id="Continuar"
                      TrailingIcon={() => <IoMdArrowForward size={20} />}
                    >
                      Continuar
                    </ContainedButton>
                    <a style={{ textDecoration: 'none' }} href="/">
                      <OutlinedButton
                        onClick={() => {}}
                        className="mb-2"
                        block
                        outline
                        icon="arrow-left"
                        text="Voltar"
                        color={theme.colors.purple}
                        name="Voltar"
                        width="100%"
                        id="Voltar"
                        LeadingIcon={() => <IoMdArrowBack size={20} />}
                      >
                        Voltar
                      </OutlinedButton>
                    </a>
                  </div>
                </Form>

                <Modal
                  show={this.state.showModal}
                  onHide={() =>
                    this.setState({ showModal: false, nfe: false, ndd: false })
                  }
                  size="lg"
                  dialogClassName="modal-90w"
                  aria-labelledby="example-custom-modal-styling-title"
                  centered
                  animation={false}
                >
                  <ModalFindYourCode />
                </Modal>
              </>
            )}
          />
        )}
      </FormBox>
    );
  }
}

const mapStateToProps = (state) => ({
  document: state.signUpReducer.document,
  customerCode: state.signUpReducer.customerCode,
});

export default connect(mapStateToProps)(SignupComponent);
